module.exports = __webpack_public_path__ + "img/prize3.75e2d895.jpg";